import { render, staticRenderFns } from "./InventorySoldStockPod.vue?vue&type=template&id=0c276b85&scoped=true"
import script from "./InventorySoldStockPod.vue?vue&type=script&lang=js"
export * from "./InventorySoldStockPod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c276b85",
  null
  
)

export default component.exports